(function () {

  function initDeliveryInfo(block) {
    if (!block) return;

    var priceEl = block.querySelector('[data-price-message]');
    var estEl = block.querySelector('[data-estimated-delivery]');

    var currentVariantPriceCents = parseInt(block.dataset.initialPrice || '0', 10) || 0;
    var cartTotalCents = 0;

    var rm48free = block.dataset.rm48free === 'true';
    var isPreorder = block.dataset.preorder === 'true';
    var country = block.dataset.country || 'GB';

    var freeDeliveryThresholdCents = 5000;

    var icons = {
      truck: '<svg class="delivery-icon" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2"></circle><circle cx="18.5" cy="18.5" r="2"></circle></svg>',

      calendar: '<svg class="delivery-icon" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="3" y1="11" x2="21" y2="11"></line></svg>',

      bolt: '<svg class="delivery-icon" viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>',

      tool: '<svg class="delivery-icon" viewBox="0 0 24 24"><path d="M14.7 6.3a4 4 0 0 0-5 5L3 18l3 3 6.7-6.7a4 4 0 0 0 5-5l-2.8 2.8-3-3z"></path></svg>',

      cart: '<svg class="delivery-icon" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1.5"></circle><circle cx="18" cy="21" r="1.5"></circle><path d="M2 3h3l2.4 12.2a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L22 7H6"></path></svg>',

      shield: '<svg class="delivery-icon" viewBox="0 0 24 24"><path d="M12 3l7 3v6c0 5-3.5 8.5-7 9-3.5-.5-7-4-7-9V6l7-3z"></path><path d="M9 12l2 2 4-4"></path></svg>'
    };

    function moneyFromCents(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    function getCartTotal() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (cart) {
          if (!cart) return;
          cartTotalCents = parseInt(cart.total_price || '0', 10) || 0;
          render();
        })
        .catch(function () {
          cartTotalCents = 0;
          render();
        });
    }

    function getFreeDeliveryMessage() {

      if (
        rm48free ||
        isPreorder ||
        cartTotalCents >= freeDeliveryThresholdCents ||
        currentVariantPriceCents >= freeDeliveryThresholdCents
      ) {
        return '';
      }

      var remainingCents = freeDeliveryThresholdCents - cartTotalCents;

      return '<div>' +
        icons.cart + ' Add ' + moneyFromCents(remainingCents) + ' more to cart for Free Delivery</div>';
    }

    function getMarketConfig(countryCode, price, combinedTotalCents) {

      if (countryCode === 'US') {
        return {
          locale: 'en-US',
          priceMessage: icons.truck + ' <span style="font-weight:500;font-size:15px;">Delivery from $18.90</span>',
          min: 5,
          max: 7,
          small: 'Tax & Duty included'
        };
      }

      if (countryCode === 'AU') {

        var auMessage;

        if (combinedTotalCents < 100000) {
          auMessage =
            icons.shield +
            ' All Tax & Duties Included';
        } else {
          auMessage =
            icons.shield +
            ' Tax & Customs Charges paid on import';
        }

        return {
          locale: 'en-AU',
          priceMessage: icons.truck + ' <span style="font-weight:500;font-size:15px;">Delivery from $18.90</span>',
          min: 5,
          max: 7,
          small: auMessage
        };
      }

      if (
        countryCode === 'FR' ||
        countryCode === 'DE' ||
        countryCode === 'IE' ||
        countryCode === 'NL' ||
        countryCode === 'BE' ||
        countryCode === 'ES' ||
        countryCode === 'IT' ||
        countryCode === 'AT' ||
        countryCode === 'PT' ||
        countryCode === 'DK' ||
        countryCode === 'SE' ||
        countryCode === 'FI' ||
        countryCode === 'PL' ||
        countryCode === 'CZ' ||
        countryCode === 'SK' ||
        countryCode === 'HU' ||
        countryCode === 'RO' ||
        countryCode === 'BG' ||
        countryCode === 'HR' ||
        countryCode === 'SI' ||
        countryCode === 'EE' ||
        countryCode === 'LV' ||
        countryCode === 'LT' ||
        countryCode === 'LU' ||
        countryCode === 'GR'
      ) {
        return {
          locale: 'en-GB',
          priceMessage: icons.truck + ' <span style="font-weight:500;font-size:15px;">International delivery available</span>',
          min: 5,
          max: 10,
          small: icons.shield + ' Tax & Duties paid on import'
        };
      }

      if (countryCode === 'GB') {

        var priceMessage;
        var combinedTotal = combinedTotalCents / 100;

        if (rm48free || combinedTotal >= 50) {

          priceMessage =
            icons.truck +
            ' <span><strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> - with <strong>free</strong> Tracked Delivery</span>';

        } else if (combinedTotal < 10) {

          priceMessage =
            icons.truck +
            ' <span><strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> with Standard Delivery from £1.99</span>';

        } else {

          priceMessage =
            icons.truck +
            ' <span><strong>' +
            moneyFromCents(currentVariantPriceCents) +
            '</strong> with Tracked Delivery from £3.89</span>';
        }

        priceMessage += getFreeDeliveryMessage();

        return {
          locale: 'en-GB',
          priceMessage: priceMessage,
          min: combinedTotal < 10 ? 3 : 2,
          max: combinedTotal < 10 ? 4 : 3,
          upgrade: icons.bolt + ' Upgrade for only 99p',
          upgradeMin: 1,
          upgradeMax: 2
        };
      }

      return {
        locale: 'en-GB',
        priceMessage: icons.truck + ' <span style="font-weight:500;font-size:15px;">International delivery available</span>',
        min: 7,
        max: 14,
        small: 'Final delivery options shown at checkout'
      };
    }

    function isBusinessDay(date) {
      var day = date.getDay();

      // Dispatch Monday-Saturday
      return day >= 1 && day <= 6;
    }

    function getDispatchDate(date) {
      var result = new Date(date);
      var day = result.getDay();

      var cutoff = new Date(date);

      // Saturday cut-off: 11:00
      if (day === 6) {
        cutoff.setHours(11, 0, 0, 0);
      }

      // Monday-Friday cut-off: 14:30
      else {
        cutoff.setHours(14, 30, 0, 0);
      }

      // After cut-off or Sunday = next dispatch day
      if (date > cutoff || !isBusinessDay(result)) {
        do {
          result.setDate(result.getDate() + 1);
        } while (!isBusinessDay(result));
      }

      return result;
    }

    // Royal Mail delivers Monday-Saturday. Only Sunday is skipped.
    function addDeliveryDays(date, days, allowSundayDelivery) {
      var result = new Date(date);
      var added = 0;

      while (added < days) {
        result.setDate(result.getDate() + 1);

        if (!allowSundayDelivery && result.getDay() === 0) {
          continue;
        }

        added++;
      }

      return result;
    }

    function formatRange(dispatchDate, min, max, locale, allowSundayDelivery) {
      var options = {
        month: 'short',
        day: 'numeric'
      };

      var validDispatchDate = getDispatchDate(dispatchDate);

      var start = addDeliveryDays(
        validDispatchDate,
        min,
        allowSundayDelivery
      );

      var end = addDeliveryDays(
        validDispatchDate,
        max,
        allowSundayDelivery
      );

      return start.toLocaleDateString(locale, options) +
             ' - ' +
             end.toLocaleDateString(locale, options);
    }

    function render() {
      var price = (currentVariantPriceCents || 0) / 100;

      var combinedTotalCents =
        cartTotalCents + currentVariantPriceCents;

      var config = getMarketConfig(
        country,
        price,
        combinedTotalCents
      );

      if (isPreorder) {

        if (priceEl) {
          priceEl.innerHTML =
            icons.tool +
            ' <span style="font-weight:500;font-size:15px;">Item made to order in the UK</span>';
        }

        if (estEl) {
          estEl.innerHTML =
            icons.calendar +
            ' Estimated Delivery: <strong>Within 2-3 weeks</strong>' +
            '<small>' +
            icons.truck +
            ' Pay now & we will ship it when in stock</small>';
        }

        return;
      }

      if (priceEl) {
        priceEl.innerHTML = config.priceMessage;
      }

      var dispatchDate = new Date();

      var standard = formatRange(
        dispatchDate,
        config.min,
        config.max,
        config.locale,
        false
      );

      /* COUNTDOWN BLOCK START */

      var now = new Date();

      var dispatchLabel = 'today';
      var cutoff = new Date(now);

      if (now.getDay() === 6) {
        cutoff.setHours(11, 0, 0, 0);
      } else {
        cutoff.setHours(14, 30, 0, 0);
      }

      if (now > cutoff || now.getDay() === 0) {

        var nextDispatch = getDispatchDate(now);

        var tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);

        if (
          nextDispatch.getDate() === tomorrow.getDate() &&
          nextDispatch.getMonth() === tomorrow.getMonth() &&
          nextDispatch.getFullYear() === tomorrow.getFullYear()
        ) {
          dispatchLabel = 'tomorrow';
        } else {
          dispatchLabel = nextDispatch.toLocaleDateString('en-GB', {
            weekday: 'long'
          });
        }

        cutoff = new Date(nextDispatch);

        if (nextDispatch.getDay() === 6) {
          cutoff.setHours(11, 0, 0, 0);
        } else {
          cutoff.setHours(14, 30, 0, 0);
        }
      }

      var diff = cutoff - now;

      var countdownHtml = '';

      if (country === 'GB' && diff > 0 && !isPreorder) {

        var hours = Math.floor(diff / (1000 * 60 * 60));
        var minutes = Math.floor((diff / (1000 * 60)) % 60);

        countdownHtml =
          '<div style="color:#5B7F3A;font-weight:600;line-height:1;margin-bottom:4px;">' +
          icons.bolt +
          ' Order within <strong>' +
          hours + 'h ' + minutes + 'm</strong> for <strong>dispatch ' +
          dispatchLabel +
          '</strong></div>';
      }

      /* COUNTDOWN BLOCK END */

      var html =
        countdownHtml +
        icons.calendar +
        ' Estimated Arrival: <strong>' +
        standard +
        '</strong>';

      if (config.upgrade) {
        var upgrade = formatRange(
          dispatchDate,
          config.upgradeMin,
          config.upgradeMax,
          config.locale,
          true
        );

        html +=
          '<small>' +
          config.upgrade +
          ': ' +
          upgrade +
          '</small>';

      } else if (config.small) {
        html +=
          '<small>' +
          config.small +
          '</small>';
      }

      if (estEl) {
        estEl.innerHTML = html;
      }
    }

    document.addEventListener('on:variant:change', function (event) {

      if (!event.detail || !event.detail.variant) return;

      currentVariantPriceCents = event.detail.variant.price;

      render();
    });

    document.addEventListener('cart:updated', getCartTotal);
    document.addEventListener('on:cart:change', getCartTotal);
    document.addEventListener('on:cart:update', getCartTotal);

    getCartTotal();
    render();
  }

  function initAll() {
    document
      .querySelectorAll('[data-delivery-info]')
      .forEach(initDeliveryInfo);
  }

  if (document.querySelector('[data-delivery-info]')) {
    initAll();
  }

})();